export default {
    methods: {
        orderNetworks(networks) {
            Object.entries(networks).forEach(([network, valuers]) => {
                if (network === 'self') {
                    valuers.order = 0
                    valuers.string = 'self'
                }
                if (network === 'leader') {
                    valuers.order = 1
                    valuers.string = 'leader'
                }
                if (network === 'team') {
                    valuers.order = 2
                    valuers.string = 'team'
                }
                if (network === 'peer') {
                    valuers.order = 3
                    valuers.string = 'peer'
                }
            })
            return networks
        },
    },
}
